(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["events-carousel"] && !Shopify.designMode) return;
  try {
    
  function setupEventsCarousel(section) {
    if (section.dataset.carouselReady === 'true') return;

    const track = section.querySelector('[data-events-carousel]');
    const previousButton = section.querySelector('[data-carousel-prev]');
    const nextButton = section.querySelector('[data-carousel-next]');

    if (!track || !previousButton || !nextButton) return;

    const cards = Array.from(track.querySelectorAll('.events-carousel__card[data-sort-index]'));

    if (cards.length > 0) {

      const parseSortIndex = (card) => {
        const eventDate = card.dataset.eventDate;

        if (eventDate) {
          const parsedDate = Date.parse(eventDate);

          if (!Number.isNaN(parsedDate)) {
            return Math.floor(parsedDate / 1000);
          }
        }

        const fallbackIndex = Number.parseInt(card.dataset.sortIndex || '99999999999', 10);

        if (!Number.isNaN(fallbackIndex)) {
          return fallbackIndex;
        }

        return Number.MAX_SAFE_INTEGER;
      };

      const isPastState = section.dataset.eventsState === 'past';

      cards
        .sort((left, right) => {
          if (isPastState) {
            return parseSortIndex(right) - parseSortIndex(left);
          }

          return parseSortIndex(left) - parseSortIndex(right);
        })
        .forEach((card) => track.appendChild(card));
    }

    track.scrollTo({ left: 0, behavior: 'auto' });

    const updateButtons = () => {
      const maxScrollLeft = track.scrollWidth - track.clientWidth - 4;

      previousButton.disabled = track.scrollLeft <= 4;
      nextButton.disabled = maxScrollLeft <= 0 || track.scrollLeft >= maxScrollLeft;
    };

    const scrollByAmount = (direction) => {
      const amount = Math.max(track.clientWidth * 0.9, 280) * direction;

      track.scrollBy({
        left: amount,
        behavior: 'smooth'
      });
    };

    previousButton.addEventListener('click', () => scrollByAmount(-1));
    nextButton.addEventListener('click', () => scrollByAmount(1));
    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);

    section.dataset.carouselReady = 'true';
    updateButtons();
  }

  document.querySelectorAll('[data-events-carousel-section]').forEach(setupEventsCarousel);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-events-carousel-section]').forEach(setupEventsCarousel);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-hero"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function init() {
      var MAX_BLUR_PX = 10; /* cap: was 30px via the old CSS scroll animation */
      var RAMP_VH = 0.9; /* saturate at 90vh of scroll, matching the old animation-range */

      var bgs = document.querySelectorAll('.rc-scrollbg');
      if (!bgs.length) return;

      /* Reduced motion: one static blur at the cap, no scroll handling at all. */
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        for (var i = 0; i < bgs.length; i++) {
          bgs[i].style.filter = 'blur(' + MAX_BLUR_PX + 'px)';
        }
        return;
      }

      var rampPx = 1; /* cached ramp length in px */
      var lastWritten = -1; /* last quantized px value applied; -1 = nothing yet */
      var ticking = false;

      /* Cache measurements; refresh only on resize/orientation change. */
      function measure() {
        rampPx = Math.max(1, window.innerHeight * RAMP_VH);
      }

      /* Whole-pixel quantized blur for a scroll offset. Linear 0 -> MAX over the ramp. */
      function quantizedBlur(scrollY) {
        var t = scrollY / rampPx;
        if (t < 0) t = 0;
        else if (t > 1) t = 1;
        return Math.round(t * MAX_BLUR_PX);
      }

      function apply(value) {
        var filter = value === 0 ? 'none' : 'blur(' + value + 'px)';
        for (var j = 0; j < bgs.length; j++) {
          bgs[j].style.filter = filter;
        }
        lastWritten = value;
      }

      /* All scroll math happens here, inside rAF. scrollY never forces layout;
         rampPx is cached, so the scroll path performs zero layout reads. */
      function update() {
        ticking = false;
        if (document.hidden) return; /* suspended while hidden; visibilitychange resumes */
        var value = quantizedBlur(window.scrollY || window.pageYOffset || 0);
        /* Write only when the rounded value changed. At saturation this writes
           the cap a single time, then stays quiet until scrolling back into the ramp. */
        if (value !== lastWritten) apply(value);
      }

      /* At most one rAF per frame; the scroll listener itself is passive. */
      function schedule() {
        if (!ticking) {
          ticking = true;
          window.requestAnimationFrame(update);
        }
      }

      measure();
      window.addEventListener('scroll', schedule, { passive: true });
      window.addEventListener('resize', function () { measure(); schedule(); });
      window.addEventListener('orientationchange', function () { measure(); schedule(); });
      document.addEventListener('visibilitychange', function () {
        if (!document.hidden) schedule();
      });
      update(); /* paint the correct blur for the initial/restored scroll position */
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', init);
    } else {
      init();
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rc-reviews-band"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var band = document.querySelector('[data-reviews-band]');
    if (!band) return;
    var rotator = band.querySelector('[data-rotator]');
    var snippets = band.querySelectorAll('[data-snippet]');
    if (snippets.length < 2) return;
    var current = 0;
    var timer = null;
    function rotate() {
      rotator.style.opacity = '0';
      setTimeout(function () {
        snippets[current].classList.remove('is-active');
        current = (current + 1) % snippets.length;
        snippets[current].classList.add('is-active');
        rotator.style.opacity = '1';
      }, 300);
    }
    function start() {
      if (!timer) timer = setInterval(rotate, 5000);
    }
    function stop() {
      if (timer) {
        clearInterval(timer);
        timer = null;
      }
    }
    start();
    band.addEventListener('mouseenter', stop);
    band.addEventListener('mouseleave', start);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  function setupReviewsFilter(section) {
    if (section.dataset.reviewsReady === 'true') return;

    const buttons = section.querySelectorAll('[data-filter]');
    const cards = section.querySelectorAll('[data-category]');
    const empty = section.querySelector('[data-reviews-empty]');

    if (buttons.length === 0) return;

    buttons.forEach((btn) => {
      btn.addEventListener('click', () => {
        buttons.forEach((b) => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        const filter = btn.getAttribute('data-filter');
        let visible = 0;
        cards.forEach((card) => {
          const show = filter === 'all' || card.getAttribute('data-category') === filter;
          card.hidden = !show;
          if (show) visible += 1;
        });
        if (empty) empty.hidden = visible > 0;
      });
    });

    section.dataset.reviewsReady = 'true';
  }

  document.querySelectorAll('[data-reviews-section]').forEach(setupReviewsFilter);

  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll?.('[data-reviews-section]').forEach(setupReviewsFilter);
  });

  } catch(e) { console.error(e); }
})();
})();
